import {useNavigate} from "react-router";
import {Outlet} from "react-router-dom";
import './main.min.css';
import {useContext, useEffect} from "react";
import {LoadingProvider, PageProvider, ToastProvider, UserContext, UserProvider} from "./contexts";
import access from "./envs/access";
import {Loading, Toast} from "./components";

function App() {
  const navigate = useNavigate();
  const {user} = useContext(UserContext);

  const isAutorizado = () => {
    try {
      let path = document.location.pathname.replace("/portalcolaborador/", "");
      let nivel = user.nivel;

      if (access[path]) {
        for (let i = 0; i < access[path].length; i++) {
          if (access[path][i] === nivel) {
            return true;
          }
        }
      } else {
        return true;
      }
      return false;
    } catch (e) {
      navigate('/portalcolaborador/login');
    }
  }


  useEffect(() => {
    if (document.location.pathname === '/portalcolaborador' || document.location.pathname === '/portalcolaborador/') {
      navigate('/portalcolaborador/login');
    } else {
      if (!isAutorizado()) {
        navigate('/portalcolaborador/login');
      }
    }
  }, []);
  // }, [location]);

  return (
    <UserProvider>
      <PageProvider>
        <LoadingProvider>
          <ToastProvider>
            <Outlet/>
            <Toast/>
            <Loading/>
          </ToastProvider>
        </LoadingProvider>
      </PageProvider>
    </UserProvider>
  );
}

export default App;
